"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepThanks = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const ScrollToTopController_1 = require("../../utils/ScrollToTopController");
const StepThanks = (props) => {
    const config = (0, configContext_1.useConfig)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ScrollToTopController_1.ScrollToTop, null),
        react_1.default.createElement("h3", null, props.type),
        react_1.default.createElement("p", null, "Die Reservationsanfrage wurde abgeschickt."),
        react_1.default.createElement("p", null, "Wir \u00FCberpr\u00FCfen nun die Anfrage und werden den Termin so bald wie m\u00F6glich best\u00E4tigen."),
        react_1.default.createElement("p", null,
            "Bei Fragen sind wir erreichbar per Mail unter",
            " ",
            react_1.default.createElement("a", { href: `mailto:${config.email}` }, config.email),
            config.phone && (react_1.default.createElement(react_1.default.Fragment, null,
                " ",
                "oder per Telefon unter",
                " ",
                react_1.default.createElement("a", { href: `tel:${config.phone}` }, config.phone)))),
        react_1.default.createElement("p", { className: "mt-5" },
            "Unter folgendem Link k\u00F6nnen die Buchungsdetails abgerufen werden:",
            " ",
            react_1.default.createElement(react_router_dom_1.Link, { to: `/bookings/${props.booking.id}/` }, "Buchung \u00F6ffnen")),
        react_1.default.createElement("p", { className: "mt-5" },
            react_1.default.createElement("a", { href: config.overview }, "Zur\u00FCck zur \u00DCbersicht"))));
};
exports.StepThanks = StepThanks;
